module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-alert v-notify v-sheet theme--dark v-alert--border v-alert--border-right",
    class: [_vm.color, {
      'show': _vm.show
    }],
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "v-alert__wrapper"
  }, [_c('i', {
    staticClass: "v-icon notranslate v-alert__icon theme--dark",
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-alert__content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-alert__border v-alert__border--right"
  }), _vm._v(" "), _c('button', {
    staticClass: "v-alert__dismissible v-btn v-btn--flat v-btn--icon v-btn--round theme--dark v-size--small",
    attrs: {
      "type": "button",
      "aria-label": "Закрыть"
    },
    on: {
      "click": _vm.destroy
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "v-btn__content"
  }, [_c('i', {
    staticClass: "v-icon notranslate fas fa-times-circle theme--dark",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3878549d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notify/Notify.vue
// module id = 349
// module chunks = 2